// ... existing code ...

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Jennifer Kowalski',
      location: 'Sterling Heights',
      rating: 5,
      text: 'Our kitchen remodel exceeded all expectations! The team was professional, punctual, and the craftsmanship is outstanding. They transformed our outdated kitchen into a modern masterpiece.',
      image: 'https://public.readdy.ai/ai/img_res/c1aa9231ad85ec91037395fba25a5d0d.jpg',
    },
    {
      name: 'Robert Chen',
      location: 'Troy',
      rating: 5,
      text: 'The bathroom renovation was completed on time and within budget. Every detail was perfect, from the tile work to the custom vanity. Highly recommend for any remodeling project!',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20man%20in%20his%2050s%20with%20confident%20expression%20standing%20in%20elegant%20modern%20bathroom%20with%20gray%20tiles%20and%20contemporary%20fixtures%20soft%20lighting%20sophisticated%20atmosphere&width=400&height=400&seq=testimonial-robert-chen&orientation=squarish',
    },
    {
      name: 'Amanda Martinez',
      location: 'Warren',
      rating: 5,
      text: 'They finished our basement and created the perfect family entertainment space. The attention to detail and quality of work is exceptional. Our home value increased significantly!',
      image: 'https://readdy.ai/api/search-image?query=Friendly%20Hispanic%20woman%20in%20her%2030s%20with%20bright%20smile%20standing%20in%20finished%20basement%20with%20modern%20entertainment%20area%20warm%20lighting%20cozy%20and%20inviting%20atmosphere&width=400&height=400&seq=testimonial-amanda-martinez&orientation=squarish',
    },
    {
      name: 'David Thompson',
      location: 'Macomb',
      rating: 5,
      text: 'From start to finish, the whole home remodel was seamless. The team communicated clearly, respected our home, and delivered results that transformed our living space completely.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20man%20in%20his%2040s%20with%20friendly%20demeanor%20standing%20in%20beautifully%20remodeled%20living%20room%20with%20modern%20furniture%20and%20elegant%20finishes%20natural%20daylight%20clean%20and%20sophisticated%20atmosphere&width=400&height=400&seq=testimonial-david-thompson&orientation=squarish',
    },
    {
      name: 'Lisa Nowak',
      location: 'Rochester Hills',
      rating: 5,
      text: 'The custom carpentry work in our home office is absolutely beautiful. Built-in shelving and crown molding added so much character. True craftsmen who take pride in their work!',
      image: 'https://readdy.ai/api/search-image?query=Professional%20woman%20in%20her%2040s%20with%20warm%20expression%20standing%20in%20elegant%20home%20office%20with%20custom%20built-in%20shelving%20and%20crown%20molding%20natural%20lighting%20refined%20and%20polished%20atmosphere&width=400&height=400&seq=testimonial-lisa-nowak&orientation=squarish',
    },
    {
      name: 'Michael Williams',
      location: 'Shelby Township',
      rating: 5,
      text: 'Our room addition blends perfectly with the existing structure. You can\'t even tell it\'s new! The quality and attention to architectural detail is remarkable. Worth every penny.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20man%20in%20his%2050s%20with%20satisfied%20smile%20standing%20in%20spacious%20new%20room%20addition%20with%20large%20windows%20and%20seamless%20integration%20natural%20lighting%20bright%20and%20airy%20atmosphere&width=400&height=400&seq=testimonial-michael-williams&orientation=squarish',
    },
  ];

  return (
    <section id="testimonials" className="py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">What Our Clients Say</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Don't just take our word for it - hear from homeowners across Southeast Michigan who trusted us with their remodeling projects.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100"
            >
              <div className="flex items-center gap-4 mb-6">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full object-cover border-2 border-teal-500"
                />
                <div>
                  <h3 className="font-bold text-gray-900 text-lg">{testimonial.name}</h3>
                  <p className="text-gray-600 text-sm">{testimonial.location}</p>
                </div>
              </div>

              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                ))}
              </div>

              <p className="text-gray-700 leading-relaxed italic">"{testimonial.text}"</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
